/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Dec 2021
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import constants from '../../../../globalization';
import FireboardUtils from '../../../../util/fireboard-util';
import styles from './Redeem.module.css';

const Voucher = props => {
  const { children, check, message, currency, iso2 } = props;
  const { vouchers, orders } = check || {};

  const voucher0 = (Array.isArray(vouchers) && vouchers.length) ? vouchers[0] : {};
  const { voucherName, issueDate, applicableDate, redeemedDate, amount, statusName } = voucher0 || {};
  const formattedIssueDate = issueDate ? `${FireboardUtils.convertedDate(issueDate)} ${FireboardUtils.getTimeInHrsMins(issueDate)}` : '';
  const formattedEventDate = applicableDate ? `${FireboardUtils.convertedDate(applicableDate)} ${FireboardUtils.getTimeInHrsMins(applicableDate)}` : '';
  const formattedRedeemDate = redeemedDate ? `${FireboardUtils.convertedDate(redeemedDate)} ${FireboardUtils.getTimeInHrsMins(redeemedDate)}` : '';
  const formattedAmount = amount ? amount : 0;
  const [order0] = orders || [];
  const { checkInNote, phoneNumber } = order0 || {};
  const formattedPhoneNumber = phoneNumber ? FireboardUtils.formattedPhoneNumber(phoneNumber, iso2) : '';

  return (
    <div className={classNames({[styles.boxWrapper]: true, [styles.errorBoxWrapper]: !!message})}>
      <div>
        <Row label={constants.nameLabel} value={voucherName} />
        <Row label={constants.issueDate} value={formattedIssueDate} />
        <Row label={constants.eventDate} value={formattedEventDate} />
        <Row label={constants.redeemDate} value={formattedRedeemDate} />
        <Row label={constants.phoneNumber} value={formattedPhoneNumber} />
        <Row label={constants.guestLabel} value={checkInNote || ''} />
        <Row label={constants.amountLabel} value={`${currency}${formattedAmount}`} />
        <Row label={constants.statusLabel} value={statusName} />
        {!!message ? <Row label={constants.messageLabel} value={message} isError={true} /> : null}
      </div>
      {children}
    </div>
  );
};

export default Voucher;

Voucher.propTypes = {
  check: PropTypes.object.isRequired,
  message: PropTypes.string,
  currency: PropTypes.string,
  iso2: PropTypes.string,
};

Voucher.defaultProps = {
  check: {},
  message: '',
  currency: '$',
  iso2: 'US',
};

const Row = ({ label, value, isError }) => {
  return (
    <div className={styles.rowContainer}>
      <div className={classNames({ [styles.rowLabel]: true, [styles.errorLabel]: isError })}>{label}:</div>
      <div className={classNames({ [styles.rowValue]: true, [styles.errorLabel]: isError })}>{value}</div>
    </div>
  );
};

Row.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  isError: PropTypes.bool,
};

Row.defaultProps = {
  label: '',
  value: '',
  isError: false,
};
